<template>
  <div class="customizer-layout-option">
    <OptionsCustomizer :options="opts"
      @input="updateSettings(`layout.${category}`, $event)"
      :value="settings.layout[category]" />
  </div>
</template>
<script>
import { mapState } from 'vuex'

import filters from '@/mixins/filters'
import update from '@/mixins/update'
import OptionsCustomizer from './OptionsCustomizer'

export default {
  mixins: [
    update,
    filters
  ],
  components: {
    OptionsCustomizer
  },
  props: {
    category: String,
    options: Array
  },
  computed: {
    ...mapState([ 'settings' ]),
    opts: function () {
      return this.options.map(opt => {
        return {
          key: opt,
          value: this.upperFirst(opt)
        }
      })
    }
  }
}
</script>
